/**
 * AdMockupCTA Component
 *
 * Call-to-action button with platform-specific styling
 */

import React from 'react';
import { cn } from '@/lib/utils';
import { AdMockupCTAProps } from '../types/base.types';

export const AdMockupCTA: React.FC<AdMockupCTAProps> = ({
  text,
  platform,
  variant = 'primary',
  fullWidth = true,
  onClick,
}) => {
  // Platform-specific styles
  const platformStyles = {
    facebook: {
      primary: 'bg-primary/10 dark:bg-primary/20 text-primary hover:bg-primary/20 dark:hover:bg-primary/30',
      secondary: 'bg-gray-100 dark:bg-white/10 text-gray-900 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-600',
      outline: 'border-2 border-primary text-primary bg-transparent hover:bg-primary/5',
    },
    meta: {
      primary: 'bg-primary/10 dark:bg-primary/20 text-primary hover:bg-primary/20 dark:hover:bg-primary/30',
      secondary: 'bg-gray-100 dark:bg-white/10 text-gray-900 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-600',
      outline: 'border-2 border-primary text-primary bg-transparent hover:bg-primary/5',
    },
    instagram: {
      primary: 'bg-primary/10 dark:bg-primary/20 text-primary hover:bg-primary/20 dark:hover:bg-primary/30',
      secondary: 'bg-gray-100 dark:bg-white/10 text-gray-900 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-600',
      outline: 'border-2 border-primary text-primary bg-transparent hover:bg-primary/5',
    },
    google_search: {
      primary: 'bg-primary text-white hover:bg-primary/90',
      secondary: 'bg-gray-100 text-gray-900 hover:bg-gray-200',
      outline: 'border border-primary text-primary bg-transparent hover:bg-primary/5',
    },
    google_display: {
      primary: 'bg-primary text-white hover:bg-primary/90',
      secondary: 'bg-gray-100 text-gray-900 hover:bg-gray-200',
      outline: 'border border-primary text-primary bg-transparent hover:bg-primary/5',
    },
    google_shopping: {
      primary: 'bg-primary text-white hover:bg-primary/90',
      secondary: 'bg-gray-100 text-gray-900 hover:bg-gray-200',
      outline: 'border border-primary text-primary bg-transparent hover:bg-primary/5',
    },
    youtube: {
      primary: 'bg-primary text-white hover:bg-primary/90',
      secondary: 'bg-white text-gray-900 hover:bg-gray-100',
      outline: 'border-2 border-white text-white bg-transparent hover:bg-white/10',
    },
    tiktok: {
      primary: 'bg-white text-black font-bold hover:bg-gray-100',
      secondary: 'bg-gray-800 text-white hover:bg-gray-700',
      outline: 'border-2 border-white text-white bg-transparent hover:bg-white/10',
    },
    linkedin: {
      primary: 'bg-primary text-white hover:bg-primary/90',
      secondary: 'bg-gray-100 text-gray-900 hover:bg-gray-200',
      outline: 'border-2 border-primary text-primary bg-transparent hover:bg-primary/5',
    },
    pinterest: {
      primary: 'bg-red-600 text-white hover:bg-red-700',
      secondary: 'bg-gray-100 text-gray-900 hover:bg-gray-200',
      outline: 'border-2 border-red-600 text-red-600 bg-transparent hover:bg-red-50',
    },
    twitter: {
      primary: 'bg-black text-white hover:bg-gray-900',
      secondary: 'bg-gray-100 text-gray-900 hover:bg-gray-200',
      outline: 'border-2 border-black text-black bg-transparent hover:bg-gray-50',
    },
  };

  const styles = platformStyles[platform]?.[variant] || platformStyles.facebook[variant];

  return (
    <button
      onClick={onClick}
      className={cn(
        'mt-3 py-2.5 px-4 rounded-md text-sm font-semibold transition-colors',
        fullWidth && 'w-full',
        styles
      )}
      type="button"
    >
      {text}
    </button>
  );
};

export default AdMockupCTA;
